import ApiClient from '@/api/ApiClient';
import { ARMADO_URL } from '@/utils/CONST';

const client = new ApiClient('agency/tempworkerdocument');

class TempWorkerDocumentApiAgency {
	static listByUserId (userId: number) {
		return client.get<ITempWorkerDocumentForAgencyModel[]>(`list/${userId}`);
	}

	static download (id: number) {
		client.windowOpen(`${ARMADO_URL}/app/agency/tempworkerdocument/${id}/file?isDownload=true`, '_blank');
	}

	static view (id: number) {
		client.windowOpen(`${ARMADO_URL}/app/agency/tempworkerdocument/${id}/file`, '_blank');
	}
}

export default TempWorkerDocumentApiAgency;
